import { useState } from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { MasterMessage } from '../../../masters/masterMessages';
import Swal from 'sweetalert2';
import ListView from '../../components/views/listView';
import ModalLoading from '../../components/general/loading/modalLoading';
import DropZoneField from '../../components/general/fields/dropzoneField';
import Grid from '@mui/material/Grid';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import { asyncPostLoadBase } from '../../../services/usersCreation.service';
import { requiredFields } from './fields';
import { CSVRender } from '../../components/csvViewer/csvViewer';
import { VerifyReplace } from '../commercialCrm/brightpattern/verifyReplace';

const UsersLoad = () => {
    const { titleList, messageError, titleModalLoading, messageModalLoading } =
        MasterMessage.usersCreation;
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState<any>([]);
    const [showCsvViewer, setShowCsvViewer] = useState(false);
    const [loadOnlyInDB, setLoadOnlyInDB] = useState(false);
    const [showVerifyReplace, setShowVerifyReplace] = useState(false);

    const handleVerifyReplace = () => {
        setShowCsvViewer(false);
        setShowVerifyReplace(true);
    };

    const handleSave = (deleteAndSave: boolean) => {
        setShowVerifyReplace(false);
        if (files.length > 0) {
            setLoading(true);
            setFiles([]);
            setLoadOnlyInDB(false);
            asyncPostLoadBase(files[0] || '', loadOnlyInDB, deleteAndSave)
                .then((body: any) => {
                    if (body.items !== undefined) {
                        setLoading(false);
                        Swal.fire({
                            title: 'Carga Exitosa',
                            text: `
                            Se cargaron ${body.items.added} de ${body.items.total} registros exitosamente,
                            donde ${body.items.duplicateKey} fueron duplicados, ${body.items.missingKey} tuvieron problemas en sus claves
                            y ${body.items.failed} fallaron al crear el usuario en CRMWARE.`,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            allowOutsideClick: false,
                            customClass: 'swal-wide-class',
                        });
                    } else {
                        Swal.fire({
                            title: 'Error Carga',
                            text: messageError,
                            icon: 'error',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            customClass: 'swal-wide-class',
                        });
                    }
                })
                .finally(() => setLoading(false));
        } else {
            SwalCustomClass.fire({
                text: 'Debe seleccionar un archivo y una lista',
                icon: 'error',
                iconColor: '#1d1d1d',
            });
        }
    };
    return (
        <>
            {loading ? (
                <ModalLoading
                    open
                    title={titleModalLoading}
                    message={messageModalLoading}
                />
            ) : (
                <>
                    <ListView
                        title={titleList}
                        titleButtonAdd={'Cargar'}
                        onClickAdd={() => setShowCsvViewer(true)}
                        startIconButtonAdd={
                            <FileUploadIcon color="secondary" />
                        }
                        disableBack
                        disableDataGrid
                        disabledAdd={!files[0]}
                    />
                    <CSVRender
                        file={files[0]?.get('file')}
                        open={showCsvViewer}
                        onCloseCsvViewer={() => setShowCsvViewer(false)}
                        onAccept={handleVerifyReplace}
                        requiredFields={requiredFields}
                    />
                    <VerifyReplace
                        open={showVerifyReplace}
                        onCloseCsvViewer={() => setShowVerifyReplace(false)}
                        onAccept={handleSave}
                    />
                    <Grid
                        container
                        spacing={{ xs: 1.5, md: 1.5 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        <Grid item xs={12} mt={3} sx={{ minWidth: 300 }}>
                            <DropZoneField
                                name="File"
                                maxFiles={1}
                                accept=".csv"
                                onChange={(value) => setFiles(value)}
                            />
                        </Grid>
                    </Grid>
                </>
            )}
        </>
    );
};

export default UsersLoad;
